import {root} from '../../../../store/constants';

export const alias = (userId: string) => {
    root.analytics && root.analytics.alias(userId);
};
